import styled from "styled-components";
import { getToneTokens, PageContainer, PageState as SharedPageState } from "../../styles/shared";

export const AuthShell = styled.div`
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: ${({ theme }) => theme.background};
`;

export const AuthCard = styled.div`
  width: min(430px, 100%);
  border-radius: var(--radius-xl);
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  padding: 26px;
  box-shadow: var(--shadow-3);
`;

// LEGACY: mantido como compat para qualquer caller antigo. Os formularios
// de auth do PharuERP agora usam o componente <PharuERPLogo> diretamente.
export const Logo = styled.img`
  width: 78px;
  display: block;
  margin-bottom: 18px;
`;

export const BrandStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 22px;
`;

export const BrandTagline = styled.span`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.textTertiary || theme.textSecondary};
`;

export const AuthTitle = styled.h1`
  font-size: 24px;
  color: ${({ theme }) => theme.textPrimary};
  margin-bottom: 6px;
`;

export const AuthSubtitle = styled.p`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
  line-height: 1.45;
  margin-bottom: 22px;
`;

export const Form = styled.form`
  display: grid;
  gap: 14px;
`;

export const Field = styled.label`
  display: grid;
  gap: 6px;
`;

export const Label = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: ${({ theme }) => theme.textSecondary};
`;

export const Input = styled.input`
  width: 100%;
  min-height: 42px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textPrimary};
  padding: 9px 11px;
  outline: none;
  font: inherit;

  &:focus {
    border-color: ${({ theme }) => theme.accent};
    background: ${({ theme }) => theme.surface};
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 96px;
  resize: vertical;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textPrimary};
  padding: 9px 11px;
  outline: none;
  font: inherit;

  &:focus {
    border-color: ${({ theme }) => theme.accent};
    background: ${({ theme }) => theme.surface};
  }
`;

export const Button = styled.button`
  min-height: 42px;
  border: 1px solid ${({ theme, $variant }) => ($variant === "secondary" ? theme.border : theme.accent)};
  border-radius: 8px;
  background: ${({ theme, $variant }) => ($variant === "secondary" ? theme.surface : theme.accent)};
  color: ${({ theme, $variant }) => ($variant === "secondary" ? theme.textSecondary : "var(--ink-on-accent)")};
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 9px 13px;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.accent};
    color: ${({ theme, $variant }) => ($variant === "secondary" ? theme.accent : "var(--ink-on-accent)")};
  }

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }
`;

export const InlineActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Message = styled.div`
  ${({ theme, $tone = "info" }) => {
    const tokens = getToneTokens(theme, $tone);
    return `
      background: ${tokens.background};
      border: 1px solid ${tokens.border};
      color: ${tokens.text};
    `;
  }}

  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.4;
`;

export const ProfilePage = styled(PageContainer)``;

export const PageState = styled(SharedPageState)``;

export const ProfileGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 420px);
  gap: 18px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Panel = styled.section`
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  border-radius: 12px;
  padding: 18px;
  display: grid;
  gap: 14px;
`;

export const PanelTitle = styled.h2`
  font-size: 15px;
  color: ${({ theme }) => theme.textPrimary};
`;

export const Avatar = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  display: grid;
  place-items: center;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 28px;
  font-weight: 800;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
